import { get, post } from './http-calls';

export const postTCardCalendarHoliday = async (data) => {
    let res = await post(`TCardCalendars/TCardCalendar_AddUpdate`, data, { useAuthToken: true });
    return res;
};
export const GetTCardDashDropdowns = async () => {
    let res = await get(`TCards/TCardDash_DropDowns`, { useAuthToken: true });
    return res;
};
export const GetTCardCalendar = async (branch, year) => {
    let res = await get(`TCardCalendars/TCardCalendar_List?BranchID=${branch}&Year=${year}`, { useAuthToken: true });
    return res;
};
export const GetTCardByBookingDate = async (date) => {
    let res = await get(`TCardCalendars/TCards_GetByBookingDate?Date=${date}`, { useAuthToken: true });
    return res;
};
